import BaseApi from "./BaseApi";

export default class SaleBillService extends BaseApi {


    constructor(){
        super();
    }


    async list(business, filter)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/sale-bills${filter}`)
        .catch(this.handleErrorResponse);
    }


    async selectData(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/sale-bills/catalog`)
        .catch(this.handleErrorResponse);
    }


    async get(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/sale-bills/${id}`)
        .catch(this.handleErrorResponse);
    }

    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/sale-bills`, data)
        .catch(this.handleErrorResponse);
    }

    async storeReceivableAccount(business, saleBillId, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/sale-bills/${saleBillId}/account-receivable`, data)
        .catch(this.handleErrorResponse);
    }


    async update(business, id, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/sale-bills/${id}`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, id)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/sale-bills/${id}`)
        .catch(this.handleErrorResponse);
    }

    pdfQuotation(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/sale-bills/${id}/quotation`,
        {
            responseType: "blob",
            headers:  { "Access-Control-Allow-Origin": "*" },
            exposedHeaders: ["Content-Disposition"],
        })
        .catch(this.handleErrorResponse);
    }



}